import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from "../../components/LoadableLoading";
import {ILoadedProps, IProps} from "./interface";

export const path = '/survey';

const PageSurvey: React.FC<IProps> = (props) => {
    // @ts-ignore
    let loader = {
        page: () => import(`./page`),
        i18n: () => import(`./ru.json`)
    };

    const LoadableMap = Loadable.Map({
        loader: loader,
        loading: LoadableLoading,
        render(loaded: ILoadedProps): React.ReactNode {
            const Page: any = loaded.page.default;

            return (
                <Page i18n={{...loaded.i18n}} {...props}/>
            );
        }
    });

    return <LoadableMap {...props} />;
};

export default PageSurvey;